import { useRecommendedAccos } from '@/scopes/products/pages/components/Legacy/RecommendedAccos/hooks'
import { horizontalGap, tk } from '@sunwebgroup/ui-components'
import useEmblaCarousel from 'embla-carousel-react'
import { styled } from 'styled-components'
import { AccoCard } from '../AccoCard'
import { AccoCardContainer } from '../AccoCard/AccoCard'
import { AccoListLoading } from './AccoListLoading'

const Slider = styled.div`
  width: 100%;

  // to show the shadow on the left side of the first card
  margin-left: -3px;

  @media ${tk('mq_tablet')} {
    overflow: hidden;
  }
`

const Wrapper = styled.div`
  display: flex;

  // to show the shadow on the left side of the first card
  margin-left: 3px;
  @media ${tk('mq_tablet')} {
    ${AccoCardContainer}:last-child {
      margin-right: ${tk('spacing_lg')};
    }
  }

  ${horizontalGap('spacing_md')}
`

export function AccoList() {
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
  })

  const { isLoading, recommendedAccos } = useRecommendedAccos()

  if (isLoading) {
    return <AccoListLoading />
  }

  return (
    <Slider ref={emblaRef}>
      <Wrapper>{recommendedAccos?.map(acco => <AccoCard key={acco.id} acco={acco} />)}</Wrapper>
    </Slider>
  )
}
